import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UserSettingsService } from './user-setting.service';
import { PermissionService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    @Inject(Router) private router: Router,
    public userServices: UserSettingsService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.userServices.validateToken()) {
      this.userServices.logOut(false);
    }
  }
}
// Desloagueado
@Injectable({
  providedIn: 'root',
})
export class OutGuard {
  constructor(
    @Inject(Router) private router: Router,
    public userServices: UserSettingsService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {}
}
// Lead Guard
@Injectable({
  providedIn: 'root',
})
export class LeadGuard {
  constructor(
    @Inject(Router) private router: Router,
    public userServices: UserSettingsService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {}
}

@Injectable({
  providedIn: 'root',
})
export class ConfigGuard {
  constructor(
    @Inject(Router) private router: Router,
    public userServices: UserSettingsService,
    public permissionService: PermissionService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isConfigEnabled = this.permissionService.hasPermission('view_config_menu_options');
    const validToken = this.userServices.validateToken();
    console.log('ConfigGuard', validToken, isConfigEnabled);
    if (!validToken || !isConfigEnabled) {
      // this.userServices.logOut();
      this.router.navigate(['pages/dashboard'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
